module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "intro"
    }
  }, [_c('br'), _vm._v(" "), _c('el-row', {
    staticClass: "pad-container"
  }, [_c('div', {
    staticClass: "pad-inner-container"
  }, _vm._l((_vm.content), function(category) {
    return _c('el-col', {
      key: category.slug,
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "pad"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": '/static/img/' + category.icon
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": '/' + category.slug
      }
    })], 1)])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74acf7a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 140
// module chunks = 1